import { Link } from "react-router-dom";
import { ProgramType } from "src/enums";
import { _ } from "src/services";

export const NotFound: React.FC<{ programType?: ProgramType }> = ({ programType }) => {
    return (
        <div className="page-404 app-theme2 pb-5 mb-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="text-light text-center py-4 my-4 h-100">
                            <h5 className="text-rtl">{_("notFound")}</h5>
                            <br />
                            <p className="text-rtl pt-2">
                                <Link to={programType === ProgramType.ArchiveVideo ? "/archive" : "/"} className="page-404-link router-link-active">
                                    {_("returnToList")}
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
